import createIcon from '../../createIcon';

/**
 * @component @name FlipToFront
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyAxM0g1VjExSDNWMTNaTTMgMTdINVYxNUgzVjE3Wk01IDIxVjE5SDNDMyAyMC4xIDMuODkgMjEgNSAyMVpNMyA5SDVWN0gzVjlaTTE1IDIxSDE3VjE5SDE1VjIxWk0xOSAzSDlDNy44OSAzIDcgMy45IDcgNVYxNUM3IDE2LjEgNy44OSAxNyA5IDE3SDE5QzIwLjEgMTcgMjEgMTYuMSAyMSAxNVY1QzIxIDMuOSAyMC4xIDMgMTkgM1pNMTkgMTVIOVY1SDE5VjE1Wk0xMSAyMUgxM1YxOUgxMVYyMVpNNyAyMUg5VjE5SDdWMjFaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FlipToFront = createIcon('FlipToFront', [
  [
    'path',
    {
      d: 'M3 13H5V11H3V13ZM3 17H5V15H3V17ZM5 21V19H3C3 20.1 3.89 21 5 21ZM3 9H5V7H3V9ZM15 21H17V19H15V21ZM19 3H9C7.89 3 7 3.9 7 5V15C7 16.1 7.89 17 9 17H19C20.1 17 21 16.1 21 15V5C21 3.9 20.1 3 19 3ZM19 15H9V5H19V15ZM11 21H13V19H11V21ZM7 21H9V19H7V21Z',
      key: 'czosap',
    },
  ],
]);

export default FlipToFront;
